export default __webpack_public_path__ + "static/media/add-new-pink.98ed07ab.svg";